import { getTheme, IStyle, mergeStyleSets } from "@fluentui/react";
import { BwjPalette } from "../../../app-theme";

// UNUSED
const listingLine: IStyle = {
  width: 'auto',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontWeight: 400, 
};

export const usePRIVATE_STYLES = (inProgress: boolean, hasWarning: boolean, contextMenuButtonWidth: number, rootFontSize?: number | undefined) => {
  const theme = getTheme();
  const listingBorderRadius = 4;

  const boxShadow = '0 1.6px 3.6px 0 rgba(0,0,0,0.132), 0 0.3px 0.9px 0 rgba(0,0,0,0.108)';
  const remValue = rootFontSize ?? theme.fonts.medium.fontSize;
  const listing: IStyle = {
    fontSize: remValue,
    position: 'relative',
    backgroundColor: theme.palette.white,
    backgroundClip: 'padding-box',
    padding: 0,
    marginBottom: 14,
    borderRadius: listingBorderRadius,
    '-webkit-box-shadow': boxShadow,
    boxShadow,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    color: theme.palette.neutralPrimary,

    '&:hover > div:first-child': {
      width: '0.5em'
    },
  };
  
  const indicatorColor = inProgress ? BwjPalette.themeSuccess :
    hasWarning ? BwjPalette.themeWarning : theme.palette.neutralTertiary;
  const stateIndicator: IStyle = {
    margin: 0,
    padding: 0,
    backgroundColor: indicatorColor,
    width: '0.4em',
  };

  const contentContainer: IStyle = {
    fontSize: '1em',
    padding: '1em',
    margin: 0,
    flexGrow: 1,
    boxSizing: 'border-box',
    width: 1,
    cursor: 'pointer',
  };

  const title: IStyle = {
    ...listingLine,
    margin: 0,
    padding: 0,
    fontSize: '1.5em',
    lineHeight: '1.5em',
    fontWeight: 400,
  };

  const descriptionContainer: IStyle = {
    fontSize: '0.9em',
    margin: 0,
    marginTop: '0.50em',
    display: 'flex',
    flexDirection: 'row',
    lineHeight: '1.5em',
    color: theme.palette.neutralPrimaryAlt,
  };

  const duration: IStyle = {
    fontWeight: 'bold',
    display: 'block',
    padding: 0,
    paddingRight: '0.5em',
    borderRight: `1px solid ${theme.palette.neutralTertiary}`,
    width: 'auto',
    whiteSpace: 'nowrap',
  };

  const description: IStyle = {
    ...listingLine,
    display: 'block',
    padding: 0,
    paddingLeft: '0.5em',
    flexGrow: 1,
  };

  const contextMenuContainer: IStyle = {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: theme.palette.neutralPrimary,
  };
  const contextMenuButtonContainer: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    position: 'absolute',
    right: 0,
    height: '100%',
  };
  const contextMenuContainer_Closed: IStyle = {
    ...contextMenuContainer,
    width: 0,
  };
  const contextMenuContainer_Open: IStyle = {
    ...contextMenuContainer,
    width: inProgress ? `${(contextMenuButtonWidth * 4)}em` : `${(contextMenuButtonWidth * 3)}em`,
  };

  return mergeStyleSets({
    listing,
    stateIndicator,
    contentContainer,
    title,
    descriptionContainer,
    duration,
    description,
    contextMenuButtonContainer,
    contextMenuContainer_Open,
    contextMenuContainer_Closed,
  });
}
